/**
 * Convert a string to a URL-safe slug.
 * e.g. "AC Mechanic" → "ac-mechanic", "Electrical Services" → "electrical-services"
 */
export function slugify(text) {
  if (!text || typeof text !== "string") return "";
  return text
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}
